export default __webpack_public_path__ + "static/media/Eiffel_Tower_Bahria_Town_Lahore.beb7f7ca.jpg";